import React from "react";
import PropTypes from "prop-types";
import get from "lodash.get";
import qs from "query-string";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { push } from "connected-react-router";
import { withRouter } from "react-router-dom";

import Button from "components/Button";
import TextField from "components/TextField";

import UserActioner from "services/user/actioner";
import paths from "routes/paths";

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
  },
  inputContainer: {
    marginBottom: "16px",
    width: "100%",
  },
  textFieldContainer: {
    marginTop: "8px",
  },
  forgotPasswordContainer: {
    flex: 1,
    textAlign: "right",
    color: "white",
    opacity: "0.85",
    cursor: "pointer",
  },
  keepLoggedInContainer: {
    flex: 1,
  },
  buttonsContainer: {
    display: "flex",
    flexDirection: "row",
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
  },
  infos: {
    color: "white",
    fontSize: "14px",
    opacity: 0.85,
  },
};

class SetPasswordFormComponent extends React.Component {
  state = {
    password: "",
    pwdValid: false,
    error: {
      password: "",
    },
  };

  componentWillMount = () => {
    const confirmToken = qs.parse(this.props.location.search).confirm_token;
    if (!confirmToken) {
      this.props.push(paths.front.login);
    }
  };

  handleChange = (e) => {
    this.setState({
      password: get(e, "target.value"),
      pwdValid: get(e, "target.value.length", 0) > 3,
    });
  };

  handleCancel = () => {
    this.props.push(paths.front.login);
  };

  handleSetPassword = () => {
    if (this.state.pwdValid) {
      const confirmToken = qs.parse(this.props.location.search).confirm_token;
      this.props
        .setFirstPassword(confirmToken, this.state.password)
        .then(() => {
          this.props.push(paths.front.login);
        });
    }
  };

  render() {
    const { intl } = this.props;

    return (
      <div style={styles.container}>
        <div style={styles.infos}>
          {intl.messages["loginScene.updatePassword.infos"]}
        </div>
        <div style={styles.inputContainer}>
          <div style={styles.textFieldContainer}>
            <TextField
              label={intl.messages["loginScene.updatePassword.labelPassword"]}
              helperText={this.state.error.password}
              error={this.state.error.password !== ""}
              onChange={this.handleChange}
              value={this.state.password}
              fullWidth
              type="password"
            />
          </div>
        </div>
        <div style={styles.buttonsContainer}>
          <Button
            style={{ marginRight: "10px" }}
            color="secondary"
            label={
              intl.messages["loginScene.forgotPassword.cancelForgotPassword"]
            }
            onClick={this.handleCancel}
          />
          <Button
            disabled={!this.state.pwdValid}
            label={
              intl.messages["loginScene.forgotPassword.validateForgotPassword"]
            }
            onClick={this.handleSetPassword}
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            marginTop: "15px",
            width: "100%",
          }}
        />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  setFirstPassword: (confirmToken, password) =>
    dispatch(UserActioner.setFirstPassword(confirmToken, password)),
  push: (route) => dispatch(push(route)),
});

SetPasswordFormComponent.defaultProps = {};

SetPasswordFormComponent.propTypes = {
  push: PropTypes.func.isRequired,
};

export default withRouter(
  connect(null, mapDispatchToProps)(injectIntl(SetPasswordFormComponent))
);
